import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/components/base-component';

@Component({
  selector: 'app-signer-success',
  templateUrl: './signer-success.component.html',
  styleUrls: ['./signer-success.component.scss']
})
export class SignerSuccessComponent extends BaseComponent implements OnInit {


  signedId?: any;

  constructor(
    private router: Router
  ) {super();}

  ngOnInit() {
    if(!sessionStorage.getItem('bodyToSign')) {
      this.router.navigateByUrl('/')
    }

    
    this.signedId = sessionStorage.getItem('document');
  }

  goToLink() {
    window.location.href = 'https://www.gocontratos.com/user-demo-request';
  }
}
